/**
 * Rótulo humano de uma categoria de denúncia (slug → texto), resolvido por i18n.
 *
 * O VALOR persistido segue sendo o slug (`assedio_moral`) — isto só afeta a
 * EXIBIÇÃO. Espelha o padrão de `competencia.*`: a lógica/valor mora no core, o
 * rótulo mora no i18n de cada app (chaves `categorias.<slug>`). Compartilhado
 * aqui para que comitê/recurso/admin resolvam o rótulo do mesmo jeito.
 *
 * Fallback ao próprio slug: categoria legada/inesperada nunca vira string vazia
 * nem quebra — aparece crua (como hoje), nunca rotula errado.
 */
export type TranslateFn = (key: string, options: { defaultValue: string }) => string;

export function categoriaLabel(t: TranslateFn, categoria: string): string {
  return t(`categorias.${categoria}`, { defaultValue: categoria });
}
